import select from 'dom-select';
import debounce from 'debounce';

export const GlobalHeader = (el) => {
  const ui = {
    el,
    body: select('body'),
    toggles: select.all('button.nav-item', document),
  };

  const closeAllSubnavs = () => {
    ui.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      delete toggle.dataset.openedBy;
      ui.body.classList.remove('subnav-open');
    });
  }

  let headerHeight = ui.el.offsetHeight;
  let lastScrollTop = 0;
  let upScrollDistance = 0;
  const scrollUpThreshold = headerHeight / 2;

  const handleBodyScroll = () => {
    if (ui.body.classList.contains('jump-scrolling')) return;

    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollTop && ui.body) {
      // down scroll code
      upScrollDistance = 0;

      if (st > (headerHeight)) {
        ui.body.classList.add('scrolled-down');
        ui.body.classList.remove('scrolled-up');
        closeAllSubnavs();
      }
    } else {
        // up scroll code
        upScrollDistance += lastScrollTop - st;

        if (upScrollDistance > scrollUpThreshold) {
          ui.body.classList.add('scrolled-up');
          ui.body.classList.remove('scrolled-down');
        }

      if (st === 0) {
        upScrollDistance = 0;
        ui.body.classList.remove('scrolled-down');
        ui.body.classList.remove('scrolled-up');
      }
    }
    // For mobile or negative scrolling
    lastScrollTop = st <= 0 ? 0 : st;
  }

  const resyncScrollPosition = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    lastScrollTop = st <= 0 ? 0 : st;
    upScrollDistance = 0;
  }

  const addEvents = () => {
    const debouncedScroll = debounce(handleBodyScroll, 10);
    window.addEventListener('scroll', debouncedScroll);
    window.addEventListener('anchorjumpend', resyncScrollPosition);
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalHeader;
